<template>
	<div>
		<b-container class="bv-example-row">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/collecting' }">使用说明</el-breadcrumb-item>
					<el-breadcrumb-item>详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="inform_content" v-loading="loading">
				<div class="title">{{informDetail.noticeTitle}}</div>
				<div class="time">
					<div><i class="el-icon-time icon"></i></div>
					<div style="margin-left: 6px;">发布时间：{{informDetail.createTime}}</div>
				</div>
				<div class="content">
					<div v-html="informDetail.noticeContent" class="HTMLCSS"></div>
				</div>
			</div>
		</b-container>
	</div>
</template>

<script>
	import {
		getNotice
	} from "@/api/lesson";
	export default {
		data() {
			return {
				informDetail: [],
				loading: false
			}
		},
		created() {
			this.loading = true
			getNotice(this.$route.query.baseId).then(response => {
				this.informDetail = response.data
				this.informDetail.noticeContent = this.informDetail.noticeContent.replace(/\<img/gi,
					'<img style="max-width:100%;height:auto" ');
				this.loading = false
			});
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.breadcrumb {
		margin: 20px 0;
		background-color: #fff;
		padding: 20px 15px;
		font-size: 18px;
	}

	.inform_content {
		background-color: #FFFFFF;
		padding: 30px;
		border-radius: 4px;
		margin-bottom: 20px;

		.title {
			text-align: center;
			font-size: 24px;
			font-weight: bold;
			color: #333333;
		}

		.time {
			margin: 30px 0;
			padding: 20px 0;
			background: #FAFAFA;
			border: 1px solid #EDEDED;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #666666;
		}

		.content {
			text-indent: 2em;
			line-height: 30px;
		}
	}
</style>